// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/Login.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/Login.tsx"); } },
  "./(auth)/PDFSelector.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/PDFSelector.tsx"); } },
  "./(auth)/PDFViewer.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/PDFViewer.tsx"); } },
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/_layout.tsx"); } },
  "./(auth)/index.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/index.tsx"); } },
  "./(auth)/index.web.tsx": { enumerable: true, get() { return require("/user/src/app/app/(auth)/index.web.tsx"); } },
  "./(tabs)/Logout.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/Logout.tsx"); } },
  "./(tabs)/PDFArchive.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/PDFArchive.tsx"); } },
  "./(tabs)/PDFSelector.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/PDFSelector.tsx"); } },
  "./(tabs)/PDFViewer.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/PDFViewer.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/index.tsx"); } },
  "./(tabs)/index.web.tsx": { enumerable: true, get() { return require("/user/src/app/app/(tabs)/index.web.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/user/src/app/app/+not-found.tsx"); } },
  "./Datepicker.tsx": { enumerable: true, get() { return require("/user/src/app/app/Datepicker.tsx"); } },
  "./Datepicker.web.tsx": { enumerable: true, get() { return require("/user/src/app/app/Datepicker.web.tsx"); } },
  "./Editionpicker.tsx": { enumerable: true, get() { return require("/user/src/app/app/Editionpicker.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/user/src/app/app/_layout.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;